var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import React, { useEffect, useState } from "react";
import "@frameworks/salesjourney/stylesheets/components/Features/PlaceOrder/MFPlaceOrderTable.scss";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import ConfirmationPopup from "@frameworks/shared-library/components/ConfirmationPopup/ConfirmationPopup";
import PopupConfirmation from "@frameworks/shared-library/components/Offerings/Generic/PopUpConfirmation/PopUpConfirmation";
import popup_info from "@frameworks/shared-library/assets/images/SalesJourney/popup_info.svg";
import duplicateOrders from "@frameworks/shared-library/assets/images/SalesJourney/duplicateOrders.svg";
import removeClient from "@frameworks/shared-library/assets/images/SalesJourney/removeClient.svg";
import { useLocation, useNavigate } from "react-router-dom";
import GenericCheckbox from "@frameworks/shared-library/components/GenericCheckbox/GenericCheckbox";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import MFPlaceOrderSchemeNameColumn from "@frameworks/salesjourney/components/Features/PlaceOrder/MutualFund/MFPlaceOrderSchemeNameColumn";
import MFPlaceOrderClientNameColumn from "@frameworks/salesjourney/components/Features/PlaceOrder/MutualFund/MFPlaceOrderClientNameColumn";
import MFPlaceOrderOrderDetailsColumn from "@frameworks/salesjourney/components/Features/PlaceOrder/MutualFund/MFPlaceOrderOrderDetailsColumn";
import MFPlaceOrderActionColumn from "@frameworks/salesjourney/components/Features/PlaceOrder/MutualFund/MFPlaceOrderActionColumn";
import MutualFund from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFund";
import TocHoc from "@frameworks/web/components/features/TOC/TocHoc";
import { nanoid } from "nanoid";
import { MFError, } from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFundConstant";
import searchDi from "@mainDi/features/Search/servicelocator";
import { SearchAssetTypeEnum } from "@frameworks/shared-library/components/Search/constant";
import clientDi from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import { accountDetails } from "@mainDi/salesDi";
import { EUserRole } from "@domains/features/ActivityBook/OrderBook/MutualFund/entities/IGetMFOrderbookSummaryEntity";
import ClientAccessValidation from "../AccessControl/ClientAccessValidation";
import GenericToast from "@frameworks/shared-library/components/GenericToast";
var numberToWords = [
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
];
export var maxPlaceOrderItems = 10;
var CONFIRMATION_POPUP_DETAILS = (_a = {},
    _a["removeClient" /* EPlaceOrderActions.REMOVE_CLIENT */] = {
        image: removeClient,
        message: "Are you sure you want to remove client?",
        leftButton: "No",
        rightButton: "Yes",
        actionType: "removeClient" /* EPlaceOrderActions.REMOVE_CLIENT */,
    },
    _a["deleteOrders" /* EPlaceOrderActions.DELETE_ORDERS */] = {
        image: popup_info,
        message: "Do you want to delete orders?",
        leftButton: "Don't Delete",
        rightButton: "Delete",
        actionType: "deleteOrders" /* EPlaceOrderActions.DELETE_ORDERS */,
    },
    _a["duplicateOrders" /* EPlaceOrderActions.DUPLICATE_ORDERS */] = {
        image: duplicateOrders,
        message: "Do you want to duplicate orders?",
        leftButton: "No",
        rightButton: "Yes",
        actionType: "duplicateOrders" /* EPlaceOrderActions.DUPLICATE_ORDERS */,
    },
    _a);
var leadRedirectionState = {
    ucc: "",
    isin: "",
};
var MFPlaceOrderTable = function () {
    var _a;
    var location = useLocation();
    var navigate = useNavigate();
    var locationState = location.state;
    var params = new URLSearchParams(location.search);
    leadRedirectionState.isin = params.get("isin");
    leadRedirectionState.ucc = params.get("ucc");
    var placeOrderScheme = ((_a = locationState === null || locationState === void 0 ? void 0 : locationState.placeOrderNavigateState) === null || _a === void 0 ? void 0 : _a.placeOrderScheme) || null;
    var duplicateOrder = (locationState === null || locationState === void 0 ? void 0 : locationState.duplicateOrder) || null;
    var defaultInvestmentType = (locationState === null || locationState === void 0 ? void 0 : locationState.defaultInvestmentType) || null;
    // *******************************************
    // *           useStates                 *
    // *******************************************
    // Initial data for place order screen
    var _b = __read(useState([]), 2), placeOrderFormData = _b[0], setPlaceOrderFormData = _b[1];
    // Current/Updated data on place order screen
    var _c = __read(useState([]), 2), updatedPlaceOrderFormData = _c[0], setUpdatedPlaceOrderFormData = _c[1];
    var _d = __read(useState(""), 2), categoryCode = _d[0], setCategoryCode = _d[1];
    var _e = __read(useState(""), 2), productCode = _e[0], setProductCode = _e[1];
    var _f = __read(useState([]), 2), selectedOrders = _f[0], setSelectedOrders = _f[1];
    var _g = __read(useState(false), 2), schemeSearchPopup = _g[0], setSchemeSearchPopup = _g[1];
    var _h = __read(useState(""), 2), targetTrxId = _h[0], setTargetTrxId = _h[1];
    var _j = __read(useState([]), 2), duplicatedOrders = _j[0], setDuplicatedOrders = _j[1];
    var _k = __read(useState(), 2), confirmationPopupDetails = _k[0], setConfirmationPopupDetails = _k[1];
    var _l = __read(useState(), 2), toastDetails = _l[0], setToastDetails = _l[1];
    var _m = __read(useState(false), 2), clientSearchPopup = _m[0], setClientSearchPopup = _m[1];
    var _o = __read(useState(false), 2), mfToc = _o[0], setMfToc = _o[1];
    var _p = __read(useState(""), 2), isin = _p[0], setIsin = _p[1];
    var _q = __read(useState(), 2), schemeCode = _q[0], setSchemeCode = _q[1];
    var _r = __read(useState(), 2), schemeGroupCode = _r[0], setSchemeGroupCode = _r[1];
    var _s = __read(useState(), 2), schemePlan = _s[0], setSchemePlan = _s[1];
    var _t = __read(useState(null), 2), clientDetailsToSidebar = _t[0], setClientDetailsToSidebar = _t[1];
    var _u = __read(useState(""), 2), placeOrderId = _u[0], setPlaceOrderId = _u[1];
    var _v = __read(useState(), 2), investmentType = _v[0], setInvestmentType = _v[1];
    var _w = __read(useState(false), 2), showClientAccessControlSidebar = _w[0], setShowClientAccessControlSidebar = _w[1];
    var _x = __read(useState(), 2), accessControlClientDetails = _x[0], setAccessControlClientDetails = _x[1];
    // *******************************************
    // *           GENERATOR FUNCTIONS           *
    // *******************************************
    var getCheckboxInput = function (trxId) {
        return (React.createElement(GenericCheckbox, { checkboxType: "han-blue", checkboxProps: {
                checked: selectedOrders.includes(trxId),
                value: trxId,
                className: "m-0",
                onChange: function (e) { return handleOnChekboxValueChange(e, trxId); },
            } }));
    };
    var generateSchemeName = function (keys) {
        //  keys[0] -> Scheme details, keys[1] -> trxId
        return (React.createElement(MFPlaceOrderSchemeNameColumn, { schemeDetails: keys[0], transactionId: keys[1], duplicatedOrders: duplicatedOrders, setShowSearchPopup: setSchemeSearchPopup, setTransactionId: setTargetTrxId, targetTransactionId: targetTrxId, showSearchPopup: schemeSearchPopup, callbackSchemeSearchSelection: handleSchemeSearchSelection }));
    };
    var generateClientName = function (keys) {
        // keys[0] -> Client details, keys[1] -> trxId
        return (React.createElement(MFPlaceOrderClientNameColumn, { clientDetails: keys[0], transactionId: keys[1], setTransactionId: setTargetTrxId, targetTransactionId: targetTrxId, searchClientPopup: clientSearchPopup, setSearchClientPopup: setClientSearchPopup, callbackDisplayConfirmationPopup: displayConfirmationPopup, callbackHandleClientSearchSelection: handleClientSearchSelection }));
    };
    var generateOrderDetails = function (keys) {
        // keys[0] -> OrderDetails, keys[1] -> Scheme details, keys[2] -> Client Details, key[3] -> trxId
        return (React.createElement(MFPlaceOrderOrderDetailsColumn, { orderDetails: keys[0], schemeDetails: keys[1], clientDetails: keys[2], placeOrderId: keys[3], callbackHandleViewAndModifyClick: handleViewAndModifyClick }));
    };
    var generateActionsColumn = function (keys) {
        // keys[0] -> trxId, keys[1] -> Scheme details, keys[2] -> Client Details
        return (React.createElement(MFPlaceOrderActionColumn, { placeOrderId: keys[0], schemeDetails: keys[1], clientDetails: keys[2], placeOrderData: updatedPlaceOrderFormData, callbackEditOrderDetails: handleViewAndModifyClick, callbackDisplayConfirmationPopup: displayConfirmationPopup, selectedOrders: selectedOrders }));
    };
    var generatePlaceOrderFormColumns = function () {
        return [
            {
                columnName: (React.createElement(React.Fragment, null, updatedPlaceOrderFormData.length > 0 && (React.createElement(GenericCheckbox, { checkboxType: "han-blue", parentClassName: selectedOrders.length !== updatedPlaceOrderFormData.length
                        ? "indeterminate-check-box"
                        : "", checkboxProps: {
                        // checked:
                        //   selectedOrders.length === updatedPlaceOrderFormData.length,
                        // value: trxId,
                        ref: function (e) {
                            if (!!e) {
                                e.indeterminate =
                                    e.checked &&
                                        selectedOrders.length !==
                                            updatedPlaceOrderFormData.length;
                            }
                        },
                        className: "m-0",
                        onChange: function (e) { return handleSelectAllOrders(e); },
                    } })))),
                key: "trxId",
                type: "string",
                applySorting: false,
                columnClassName: "check-box-column",
                arrows: false,
                tdCustomFunction: getCheckboxInput,
            },
            {
                columnName: "Product (".concat(updatedPlaceOrderFormData.length, "/10)"),
                type: "string",
                keysForCustomFunction: ["scheme", "trxId"],
                tdCustomFunction: generateSchemeName,
            },
            {
                columnName: "Client",
                arrows: true,
                type: "string",
                applySorting: true,
                sortKey: "clientName",
                keysForCustomFunction: ["clientDetails", "trxId"],
                tdCustomFunction: generateClientName,
            },
            {
                columnName: "Order Details",
                arrows: false,
                applySorting: false,
                keysForCustomFunction: [
                    "orderDetails",
                    "scheme",
                    "clientDetails",
                    "trxId",
                ],
                tdCustomFunction: generateOrderDetails,
            },
            {
                columnName: "Action",
                keysForCustomFunction: ["trxId", "scheme", "clientDetails"],
                tdCustomFunction: generateActionsColumn,
            },
        ];
    };
    // *******************************************
    // *           HANDLER FUNCTIONS             *
    // *******************************************
    var handleClientSearchSelection = function (data) {
        var _a;
        if (((_a = data === null || data === void 0 ? void 0 : data.ispansearch) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "true") {
            //start access control flow by opening sidebar with these details
            setAccessControlClientDetails(data);
            setShowClientAccessControlSidebar(true);
            return;
        }
        if (data.accType.toUpperCase() == "REG") {
            var popupDetails = {
                image: MFError.regAccount.icon,
                message: MFError.regAccount.title,
                description: MFError.regAccount.description,
                leftButton: "",
                rightButton: "",
            };
            setConfirmationPopupDetails(popupDetails);
        }
        else {
            updateClientDetails(data, targetTrxId);
        }
        setClientSearchPopup(false);
        setTargetTrxId("");
    };
    var handleAddMoreOrders = function () {
        var tempRowData = {
            trxId: nanoid(),
            scheme: null,
            clientDetails: null,
            orderDetails: null,
            clientName: null,
        };
        setInvestmentType(undefined);
        setUpdatedPlaceOrderFormData(function (placeOrderFormData) { return __spreadArray(__spreadArray([], __read(placeOrderFormData), false), [
            tempRowData,
        ], false); });
    };
    var handleSchemeSearchSelection = function (data) {
        var tempData = updatedPlaceOrderFormData.map(function (item) {
            if (item.trxId === targetTrxId) {
                return __assign(__assign({}, item), { scheme: {
                        schemeCode: data.schemeCode,
                        schemeName: data.mfName,
                        catName: data.categoryName,
                        subCatName: data.subCategoryName,
                        amcLogo: data === null || data === void 0 ? void 0 : data.amcLogo,
                        isin: data.isin,
                        token: null,
                        categoryCode: data === null || data === void 0 ? void 0 : data.categoryCode,
                        productCode: data === null || data === void 0 ? void 0 : data.productCode,
                        schemeGroup: (data === null || data === void 0 ? void 0 : data.schemegroup) || data.schemeGroup,
                        schemeplan: (data === null || data === void 0 ? void 0 : data.schemeplan) || (data === null || data === void 0 ? void 0 : data.schPlan),
                    } });
            }
            return item;
        });
        setUpdatedPlaceOrderFormData(tempData);
        setSchemeSearchPopup(false);
        setTargetTrxId("");
    };
    var handleRemoveClient = function (trxId) {
        var tempData = updatedPlaceOrderFormData.map(function (item) {
            if (item.trxId === trxId) {
                return __assign(__assign({}, item), { clientDetails: null, orderDetails: null, clientName: null });
            }
            return item;
        });
        setUpdatedPlaceOrderFormData(tempData);
    };
    var handleViewAndModifyClick = function (schemeDetails, clientDetails, placeOrderId) {
        if (schemeDetails) {
            var selectedOrder = updatedPlaceOrderFormData.find(function (order) { return order.trxId === placeOrderId; });
            if (selectedOrder) {
                setInvestmentType(selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.investmentType);
            }
            setIsin(schemeDetails.isin);
            setPlaceOrderId(placeOrderId);
            setSchemeGroupCode(schemeDetails.schemeGroup);
            setSchemePlan(schemeDetails.schemeplan);
            setSchemeCode(schemeDetails.schemeCode);
            setCategoryCode(schemeDetails.categoryCode);
            setProductCode(schemeDetails.productCode);
            setClientDetailsToSidebar({
                clientCode: clientDetails.clientCode,
                clientName: clientDetails.clientName,
                uniqueClientId: clientDetails.uniqueClientId,
                userName: clientDetails.userName,
                accType: clientDetails.accType,
                dpFlag: clientDetails.dpFlag,
                direct_plan_enabled_flg: clientDetails.direct_plan_enabled_flg,
                clientTier: clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.clientTier,
                pan: clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.pan,
            });
            setMfToc(true);
        }
    };
    var handleOnChekboxValueChange = function (event, trxId) {
        var checkedItems = selectedOrders.slice();
        if (event.currentTarget.checked && !selectedOrders.includes(trxId)) {
            checkedItems.push(trxId);
        }
        else {
            var currentItemIndex = checkedItems.indexOf(trxId);
            if (currentItemIndex !== -1) {
                checkedItems.splice(currentItemIndex, 1);
            }
        }
        setSelectedOrders(checkedItems);
    };
    var handleSelectAllOrders = function (event) {
        var checkedItems = selectedOrders.slice();
        if (event.currentTarget.checked) {
            updatedPlaceOrderFormData.forEach(function (order) {
                if (!selectedOrders.includes(order.trxId)) {
                    checkedItems.push(order.trxId);
                }
            });
        }
        else {
            setSelectedOrders([]);
            return;
        }
        setSelectedOrders(checkedItems);
    };
    var deleteTimeout;
    var handleDeleteOrders = function (ordersToDelete) {
        if (ordersToDelete.length > 0) {
            var tempData_1 = updatedPlaceOrderFormData.slice();
            var checkedItems_1 = selectedOrders.slice();
            ordersToDelete.forEach(function (orderId) {
                // Remove order from list
                tempData_1.splice(tempData_1.findIndex(function (order) { return order.trxId === orderId; }), 1);
                // Remove orderid from selected list
                checkedItems_1.splice(checkedItems_1.findIndex(function (itemId) { return itemId === orderId; }), 1);
            });
            setUpdatedPlaceOrderFormData(tempData_1);
            if (tempData_1.length === 0) {
                setSelectedOrders([]);
                if (deleteTimeout) {
                    clearTimeout(deleteTimeout);
                }
                deleteTimeout = setTimeout(function () {
                    handleAddMoreOrders();
                }, 100);
            }
            else {
                setSelectedOrders(checkedItems_1);
            }
        }
    };
    var handleDuplicateOrders = function (orderIdToDuplicate) {
        var tempRowData = [];
        var tempDuplicatedOrders = [];
        orderIdToDuplicate.forEach(function (orderId) {
            var _a;
            var tempTrxId = nanoid();
            var orderToDuplicate = updatedPlaceOrderFormData.find(function (order) { return order.trxId === orderId; });
            tempRowData.push({
                trxId: tempTrxId,
                scheme: orderToDuplicate.scheme,
                clientDetails: orderToDuplicate.clientDetails,
                orderDetails: null,
                clientName: (_a = orderToDuplicate === null || orderToDuplicate === void 0 ? void 0 : orderToDuplicate.clientDetails) === null || _a === void 0 ? void 0 : _a.clientName,
            });
            tempDuplicatedOrders.push(tempTrxId).toString();
        });
        setDuplicatedOrders(function (previousDuplicatedOrders) { return __spreadArray(__spreadArray([], __read(previousDuplicatedOrders), false), __read(tempDuplicatedOrders), false); });
        setToastDetails({
            msg: "".concat(numberToWords[orderIdToDuplicate.length - 1] === "One"
                ? "Order has"
                : numberToWords[orderIdToDuplicate.length - 1] + " orders have", " been duplicated"),
            isError: false,
            isShow: true,
        });
        setUpdatedPlaceOrderFormData(function (prevUpdatedPlaceOrderFormData) { return __spreadArray(__spreadArray([], __read(tempRowData), false), __read(prevUpdatedPlaceOrderFormData), false); });
        setSelectedOrders([]);
    };
    var displayConfirmationPopup = function (actionType, data, fromFooter) {
        if (fromFooter === void 0) { fromFooter = false; }
        var popupDetails = __assign({}, CONFIRMATION_POPUP_DETAILS[actionType]);
        popupDetails.params = data;
        if (selectedOrders.length > 0 && fromFooter) {
            popupDetails.message =
                actionType === "deleteOrders" /* EPlaceOrderActions.DELETE_ORDERS */
                    ? "Do you want to delete ".concat(selectedOrders.length, " order").concat(selectedOrders.length === 1 ? "" : "s", "?")
                    : actionType === "duplicateOrders" /* EPlaceOrderActions.DUPLICATE_ORDERS */
                        ? "Do you want to duplicate ".concat(selectedOrders.length, " order").concat(selectedOrders.length === 1 ? "" : "s", "?")
                        : popupDetails.message;
        }
        setConfirmationPopupDetails(popupDetails);
    };
    var handleConfirmationPopupApproval = function (actionType, data) {
        switch (actionType) {
            case "removeClient" /* EPlaceOrderActions.REMOVE_CLIENT */:
                handleRemoveClient(data[0]);
                break;
            case "deleteOrders" /* EPlaceOrderActions.DELETE_ORDERS */:
                handleDeleteOrders(data);
                break;
            case "duplicateOrders" /* EPlaceOrderActions.DUPLICATE_ORDERS */:
                handleDuplicateOrders(data);
                break;
            default:
                break;
        }
        setConfirmationPopupDetails(null);
    };
    var setupPlaceOrderFromRedirect = function (isin, uccCode) { return __awaiter(void 0, void 0, void 0, function () {
        var initialPlaceOrderData, loginCode, loginType, userType, getClientForSelectedRMPayload, _a, schemeResp, clientResp, schemeResults, clientResults, err_1;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    initialPlaceOrderData = [];
                    return [4 /*yield*/, accountDetails.getUserLoginCode()];
                case 1:
                    loginCode = _f.sent();
                    return [4 /*yield*/, accountDetails.getUserLoginType()];
                case 2:
                    loginType = _f.sent();
                    userType = (function () {
                        switch (loginType) {
                            case EUserRole.RM:
                                return "Employee";
                            case EUserRole.PARTNER:
                                return "Partner";
                            default:
                                return "";
                        }
                    })();
                    getClientForSelectedRMPayload = {
                        userType: userType,
                        userId: loginCode,
                        searchText: uccCode,
                        page: "1",
                        pageSize: "100",
                    };
                    _f.label = 3;
                case 3:
                    _f.trys.push([3, 5, 6, 7]);
                    return [4 /*yield*/, Promise.allSettled([
                            searchDi.search.getAssetTypeSearch(SearchAssetTypeEnum.MF, {
                                searchText: isin,
                            }),
                            clientDi.clients.searchClientsByRmWithOwnClient(getClientForSelectedRMPayload),
                        ])];
                case 4:
                    _a = __read.apply(void 0, [_f.sent(), 2]), schemeResp = _a[0], clientResp = _a[1];
                    schemeResults = schemeResp.status === "fulfilled" &&
                        ((_c = (_b = schemeResp.value) === null || _b === void 0 ? void 0 : _b.mutualFunds) === null || _c === void 0 ? void 0 : _c.length) > 0
                        ? schemeResp.value.mutualFunds[0]
                        : null;
                    clientResults = clientResp.status === "fulfilled" && ((_d = clientResp.value) === null || _d === void 0 ? void 0 : _d.length) > 0
                        ? clientResp.value[0]
                        : null;
                    initialPlaceOrderData.push({
                        trxId: nanoid(),
                        scheme: schemeResults
                            ? {
                                schemeCode: schemeResults.schemeCode,
                                schemeName: schemeResults.mfName,
                                catName: schemeResults.categoryName,
                                subCatName: schemeResults.subCategoryName,
                                amcLogo: schemeResults === null || schemeResults === void 0 ? void 0 : schemeResults.amcLogo,
                                isin: schemeResults.isin,
                                token: null,
                                categoryCode: schemeResults === null || schemeResults === void 0 ? void 0 : schemeResults.categoryCode,
                                productCode: schemeResults === null || schemeResults === void 0 ? void 0 : schemeResults.productCode,
                                schemeGroup: schemeResults.schemegroup || schemeResults.schemeGroup,
                                schemeplan: schemeResults.schemeplan,
                            }
                            : null,
                        clientDetails: clientResults
                            ? {
                                clientName: clientResults.clientName,
                                clientCode: clientResults.accountCode,
                                uniqueClientId: clientResults.ucccode,
                                userName: clientResults.userName,
                                accType: clientResults.accType,
                                dpFlag: clientResults.dpFlag,
                                clientTier: clientResults.clientTier,
                                pan: clientResults.pan,
                            }
                            : null,
                        orderDetails: null,
                        clientName: null,
                        investmentType: defaultInvestmentType,
                    });
                    handleViewAndModifyClick(initialPlaceOrderData[0].scheme, initialPlaceOrderData[0].clientDetails, initialPlaceOrderData[0].trxId);
                    return [3 /*break*/, 7];
                case 5:
                    err_1 = _f.sent();
                    console.error("err", err_1);
                    return [3 /*break*/, 7];
                case 6:
                    setUpdatedPlaceOrderFormData(__spreadArray([], __read(initialPlaceOrderData), false));
                    setInvestmentType(((_e = initialPlaceOrderData[0]) === null || _e === void 0 ? void 0 : _e.investmentType) || undefined);
                    navigate(".", { replace: true }); // clearing the location state
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleOnClientValidationSuccess = function (clientDetails, transactionId) {
        updateClientDetails(clientDetails, transactionId);
    };
    // *******************************************
    // *           Miscellaneous                 *
    // *******************************************
    var updateClientDetails = function (data, targetRowId) {
        var tempData = updatedPlaceOrderFormData.map(function (item) {
            if (item.trxId === targetRowId) {
                return __assign(__assign({}, item), { clientDetails: {
                        clientName: data.clientName,
                        clientCode: data.accountCode,
                        uniqueClientId: data.ucccode,
                        userName: data.userName,
                        accType: data.accType,
                        dpFlag: data.dpFlag,
                        direct_plan_enabled_flg: data.direct_plan_enabled_flg,
                        clientTier: data.clientTier,
                        pan: data.pan,
                        ispansearch: data.ispansearch,
                    }, clientName: data.clientName });
            }
            return item;
        });
        setUpdatedPlaceOrderFormData(tempData);
    };
    // *******************************************
    // *           UseEffects                    *
    // *******************************************
    useEffect(function () {
        var _a;
        var initialPlaceOrderData = [];
        if (leadRedirectionState.isin || leadRedirectionState.ucc) {
            setupPlaceOrderFromRedirect(leadRedirectionState.isin, leadRedirectionState.ucc);
        }
        if (duplicateOrder) {
            initialPlaceOrderData.push({
                trxId: nanoid(),
                scheme: {
                    schemeCode: duplicateOrder.scheme.grpCode,
                    schemeName: duplicateOrder.scheme.isinName,
                    catName: duplicateOrder.scheme.catName,
                    subCatName: duplicateOrder.scheme.subCatName,
                    amcLogo: duplicateOrder.scheme.amcLogo,
                    isin: duplicateOrder.scheme.isin,
                    schemeplan: duplicateOrder.scheme.schPlan,
                    token: duplicateOrder.scheme.token,
                    categoryCode: null,
                    productCode: null,
                    schemeGroup: duplicateOrder.groupCode,
                },
                clientDetails: {
                    clientCode: duplicateOrder.clientCode,
                    clientName: duplicateOrder.clientName,
                    uniqueClientId: duplicateOrder.ucc,
                    dpFlag: duplicateOrder === null || duplicateOrder === void 0 ? void 0 : duplicateOrder.dpFlag,
                    direct_plan_enabled_flg: duplicateOrder === null || duplicateOrder === void 0 ? void 0 : duplicateOrder.direct_plan_enabled_flg,
                    pan: duplicateOrder === null || duplicateOrder === void 0 ? void 0 : duplicateOrder.pan,
                    clientTier: duplicateOrder.clientTier,
                },
                orderDetails: null,
                clientName: duplicateOrder.clientName,
                investmentType: defaultInvestmentType,
            });
            handleViewAndModifyClick(initialPlaceOrderData[0].scheme, initialPlaceOrderData[0].clientDetails, initialPlaceOrderData[0].trxId);
        }
        else {
            // When navigated from product bouquet by clicking on Place Order button or 3dots Star
            initialPlaceOrderData.push({
                trxId: nanoid(),
                scheme: Boolean(placeOrderScheme) ? placeOrderScheme : null,
                clientDetails: null,
                orderDetails: null,
                clientName: null,
                investmentType: Boolean(placeOrderScheme)
                    ? defaultInvestmentType
                    : undefined,
            });
        }
        setUpdatedPlaceOrderFormData(__spreadArray([], __read(initialPlaceOrderData), false));
        setInvestmentType(initialPlaceOrderData
            ? (_a = initialPlaceOrderData[0]) === null || _a === void 0 ? void 0 : _a.investmentType
            : undefined);
    }, []);
    // *******************************************
    // *            Rendering                    *
    // *******************************************
    return (React.createElement(React.Fragment, null,
        React.createElement(GridContainer, { parentClass: "primary-place-order-mfcontainer mw-100 " },
            React.createElement("div", { className: "d-flex flex-column secondary-place-order-mfcontainer" },
                React.createElement("div", { className: "primary-place-order-table-mfcontainer" },
                    React.createElement("div", { className: "primary-place-order-table-wrapper" },
                        React.createElement(GenericTable, { columns: generatePlaceOrderFormColumns(), data: updatedPlaceOrderFormData, parentClassName: "place-order-table common-compact-table-wrapper", sortIconUp: "edel-icon-arrow-up-thin", sortIconDown: "edel-icon-arrow-down", rowClassName: function (ele) {
                                return __spreadArray(__spreadArray([], __read(selectedOrders), false), __read(duplicatedOrders), false).findIndex(function (x) { return x === ele.trxId; }) === -1
                                    ? ""
                                    : "highlighted-row";
                            } }),
                        React.createElement("div", { className: "d-flex justify-content-center pt-20 pb-10" },
                            React.createElement("button", { className: "d-flex flex-row gap-2 align-items-center bg_white add-more-orders-btn border-btn-disabled", onClick: handleAddMoreOrders, disabled: updatedPlaceOrderFormData.length === maxPlaceOrderItems },
                                React.createElement("i", { className: "edel-icon-plus-thin" }),
                                React.createElement("span", { className: "DMSan_14_500" }, "Add more orders"))))),
                React.createElement("div", { className: "d-flex flex-row gap-2 align-items-center place-order-footer-container justify-content-between ".concat(selectedOrders.length > 0 ? "" : "d-none") },
                    React.createElement("div", { className: "d-flex flex-row gap-2 ".concat(selectedOrders.length > 0
                            ? "visibility-visible"
                            : "visibility-hidden") },
                        React.createElement("button", { className: "d-flex flex-row gap-2 align-items-center bg_white left-footer-btn cursor-pointer", onClick: function () {
                                return displayConfirmationPopup("deleteOrders" /* EPlaceOrderActions.DELETE_ORDERS */, selectedOrders, true);
                            } },
                            React.createElement("i", { className: "edel-icon-delete-red1 cursor-pointer" }),
                            React.createElement("span", { className: "DMSans_13_400 cursor-pointer" }, "Delete Orders")),
                        React.createElement("button", { className: "d-flex flex-row gap-2 align-items-center bg_white left-footer-btn cursor-pointer border-btn-disabled", onClick: function () {
                                return displayConfirmationPopup("duplicateOrders" /* EPlaceOrderActions.DUPLICATE_ORDERS */, selectedOrders, true);
                            }, disabled: updatedPlaceOrderFormData.length === maxPlaceOrderItems ||
                                selectedOrders.length >
                                    maxPlaceOrderItems - updatedPlaceOrderFormData.length },
                            React.createElement("i", { className: "edel-icon-duplicate-1 cursor-pointer" }),
                            React.createElement("span", { className: "DMSans_13_400 cursor-pointer" }, "Duplicate Orders"))),
                    React.createElement("div", null)))),
        confirmationPopupDetails && (React.createElement(ConfirmationPopup, { show: true, popTitle: "", showFooter: false, popupClass: "", isShowHeader: false },
            React.createElement(PopupConfirmation, { onFirsBtnClick: function () { return setConfirmationPopupDetails(null); }, onClose: function () { return setConfirmationPopupDetails(null); }, onSecondBtnClick: function () {
                    return handleConfirmationPopupApproval(confirmationPopupDetails.actionType, confirmationPopupDetails.params);
                }, message: confirmationPopupDetails.message, description: confirmationPopupDetails.description, confirmationImageSrc: confirmationPopupDetails.image, buttonFirstTitle: confirmationPopupDetails.leftButton, buttonSecTitle: confirmationPopupDetails.rightButton }))),
        toastDetails && (React.createElement(React.Fragment, null,
            React.createElement(GenericToast, { message: React.createElement("div", { className: "d-flex align-items-center gap-2" },
                    (toastDetails === null || toastDetails === void 0 ? void 0 : toastDetails.isError) ? (React.createElement("span", { className: "edel-icon-red-cross rounded-circle" })) : (React.createElement("span", { className: "edel-icon-tick bg-lime-green rounded-circle" })),
                    React.createElement("span", null, toastDetails === null || toastDetails === void 0 ? void 0 : toastDetails.msg)), showHeader: false, position: "bottom-center", showCloseButtonInBody: true, theme: "dark-slate-blue", show: toastDetails === null || toastDetails === void 0 ? void 0 : toastDetails.isShow, setClose: function () {
                    setToastDetails({ isShow: false, isError: false, msg: "" });
                }, autohide: true, parentClassName: "place-order-validation-toast" }))),
        mfToc && (React.createElement(TocHoc, { component: MutualFund, clientDetails: clientDetailsToSidebar, isin: isin, categoryCode: categoryCode, productCode: productCode, schemeCode: schemeCode, schemeGroupCode: schemeGroupCode, schemeplan: schemePlan, onlyEQACC: true, investmentType: investmentType, dontCloseOnOutsideClick: true, setShowTOC: function () {
                setMfToc(false);
                setPlaceOrderId("");
                setIsin("");
                setSchemeCode("");
                setSchemeGroupCode("");
                setSchemePlan("");
                setClientDetailsToSidebar(null);
            }, outsideClick: function () {
                setMfToc(false);
                setPlaceOrderId("");
                setIsin("");
                setSchemeCode("");
                setSchemeGroupCode("");
                setSchemePlan("");
                setClientDetailsToSidebar(null);
                setInvestmentType(undefined);
            }, showToc: mfToc, placeOrderId: placeOrderId, deleteOrderedItemFromPlaceOrderTable: handleDeleteOrders, blurBackground: true })),
        showClientAccessControlSidebar && (React.createElement(ClientAccessValidation, { setVisible: setShowClientAccessControlSidebar, visible: showClientAccessControlSidebar, clientDetails: accessControlClientDetails, setToastDetails: setToastDetails, callBackOnVerifyClick: handleOnClientValidationSuccess, callBackOnCancelClick: function () {
                handleRemoveClient(targetTrxId);
                setClientSearchPopup(false);
                setShowClientAccessControlSidebar(false);
            }, callBackOnSideBarClose: function () {
                handleRemoveClient(targetTrxId);
                setClientSearchPopup(false);
            }, targetRowId: targetTrxId }))));
};
export default MFPlaceOrderTable;
